import React from 'react';
import { IconProps, MaestroComponent } from '@landr/maestro';
import * as Styled from './styled';

interface InstrumentCardProps {
    icon: MaestroComponent<IconProps, Record<string, any>>;
    description: string;
    onClick: () => void;
}

const InstrumentCard: React.FC<InstrumentCardProps> = ({
    icon: Icon,
    description,
    onClick,
}) => (
    <Styled.Card onClick={onClick}>
        <Styled.Container>
            <Styled.Content
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                <Icon />
                <Styled.ResponsiveText as="h3" fontWeight="bold">
                    {description}
                </Styled.ResponsiveText>
            </Styled.Content>
        </Styled.Container>
    </Styled.Card>
);

export default InstrumentCard;
